module.exports = __webpack_public_path__ + "img/collaborate-right-jewelry-path-1.b1be64ba.svg";